import { FleekError } from './FleekError';

type RecoveryCodesAlreadyExistsErrorOptions = Record<string, never>;

export class RecoveryCodesAlreadyExistsError extends FleekError<RecoveryCodesAlreadyExistsErrorOptions> {
  public name = 'RecoveryCodesAlreadyExistsError';

  toString = () => 'Recovery codes already exists.';
}
